import styled from 'styled-components'

import { ReactComponent as ChevronVertical } from '@sketch/icons/chevron-down-17'

export const DropdownChevron = styled(ChevronVertical).attrs({
  role: 'img',
})`
  width: 17px;
  height: 17px;
`
